import { useMemo } from "react";

import Setting from "@mapmycustomers/shared/types/Setting";

const useSetting = (settings: Setting[], setting: string, defaultValue?: any) =>
  useMemo(
    () => settings.find(({ key }) => key === setting) ?? defaultValue,
    [settings, setting, defaultValue]
  );

export default useSetting;
